import React from 'react';
import {
  Box,
  LinearProgress,
  createStyles,
  makeStyles,
} from '@material-ui/core';
import colors from '../../../assets/styles/colors';
import Typography from '../typography';

const useStyles = makeStyles(theme =>
  createStyles({
    root: {
      width: '100%',
      position: 'fixed',
      bottom: 0,
      left: 0,
    },
    bar: {
      backgroundColor: colors.success.green,
      transformOrigin: 'left',
      transition: 'transform 3s ease-in-out',
    },
    barColorPrimary: {
      transform: 'scaleX(-1)',
    },
  }),
);

const ProgressBar: React.FC = () => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Box component="div" style={{ alignItems: 'center' }}>
        <Typography color="secondary" textAlign="right" mr={10} mb={2}>
          Publicando frete....
        </Typography>
      </Box>
      <LinearProgress
        style={{
          height: 10,
          backgroundColor: colors.success.paleLime,
        }}
        classes={{
          barColorPrimary: classes.barColorPrimary,
          bar: classes.bar,
        }}
      />
    </Box>
  );
};

export default ProgressBar;
